var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('b-card', {
    staticStyle: {
      "max-height": "800px",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('h4', [_vm._v("Activity Log for Site List")]), _c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_vm._v(" Back ")])], 1), _c('app-timeline', [_vm._l(_vm.rows, function (row) {
    return [row.event === 'created' ? _c('app-timeline-item', {
      key: row.id
    }, [_c('div', {
      staticClass: "d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
    }, [_c('h6', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatMsg(row.log_name, row.properties, row.event))
      }
    }), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("Created: " + _vm._s(_vm.formatDate(row.created_at)))])])]) : _vm._e(), row.event === 'updated' && Object.keys(_vm.getFilteredChanges(row.properties.changes)).length > 0 ? _c('app-timeline-item', {
      key: row.id + '-updated',
      attrs: {
        "variant": "warning"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
    }, [_c('h6', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatMsg(row.log_name, row.properties, row.event))
      }
    }), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("Updated: " + _vm._s(_vm.formatDate(row.created_at)))])]), _c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: 'report-list-' + row.id,
        expression: "'report-list-' + row.id"
      }, {
        name: "ripple",
        rawName: "v-ripple.400",
        value: 'rgba(113, 102, 240, 0.15)',
        expression: "'rgba(113, 102, 240, 0.15)'",
        modifiers: {
          "400": true
        }
      }],
      attrs: {
        "size": "sm",
        "variant": "outline-primary"
      }
    }, [_vm._v(" Show Changes ")]), _c('b-collapse', {
      attrs: {
        "id": 'report-list-' + row.id
      }
    }, [_c('b-list-group', {
      staticClass: "mt-1",
      attrs: {
        "flush": ""
      }
    }, [_c('b-list-group-item', {
      staticClass: "d-flex justify-content-between align-items-center bg-transparent"
    }, [_c('ul', _vm._l(_vm.getFilteredChanges(row.properties.changes), function (oldValue, key) {
      return _c('li', {
        key: 'old-' + key
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.formatUpdatedValues(key, oldValue, row.properties.changes.new[key], row.log_name))
        }
      })]);
    }), 0)])], 1)], 1)], 1) : _vm._e(), row.event !== 'created' && row.event !== 'updated' ? _c('app-timeline-item', {
      key: row.id + '-other',
      attrs: {
        "variant": "info"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
    }, [_c('h6', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatMsg(row.log_name, row.properties, row.event))
      }
    }), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm._f("titleCase")(row.event)) + ": " + _vm._s(_vm.formatDate(row.created_at)))])])]) : _vm._e()];
  })], 2), _vm.rows.length === 0 ? _c('div', {
    staticClass: "text-center py-5"
  }, [_c('p', [_vm._v("No activity logs found for this site list.")])]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }